export const REST = "REST";
export const GRAPHQL = "GraphQL";
export const LOADING = "loading...";
export const ERROR = "Error occurred, please wait or try again!";

// add all endpoints here
// these can be further customised based on supported path in REST and Graphql
export const ALL_ENDPOINTS = [
  {
    name: "users",
    path: "/users",
    supportedMethods: "GET",
    supportedActions: ["Test"],
  },
  {
    name: "products",
    path: "/products",
    supportedMethods: "GET",
    supportedActions: ["Test"],
  },
];
export const DEFAULT_PATH = ALL_ENDPOINTS[0].path;